import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=311cd6eb&scoped=true"
import script from "./restaurant.vue?vue&type=script&lang=js"
export * from "./restaurant.vue?vue&type=script&lang=js"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=311cd6eb&prod&lang=css"
import style1 from "./restaurant.vue?vue&type=style&index=1&id=311cd6eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311cd6eb",
  null
  
)

export default component.exports